module.exports = __webpack_public_path__ + "static/media/icon-notify.b79012cd.svg";